import { PlayerUserDetailSkeleton } from "components/Skeleton/PlayerUsersPage/PlayerUserDetailSkeleton";
import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import client from "libs/client";
import { useEffect } from "react";
import { useParams } from "react-router";
import SkeletonBox from "ui-kit/src/Skeleton/SkeletonBox";
import NotFoundPage from "./errorPages/NotFoundPage";
import { DiscoverTeamGetResponse } from "libs/apiClient";
import {DiscoverTeamDetail} from "features/discover/DiscoverTeamDetail";
import {DiscoverBreadcrumbs} from "features/discover/DiscoverBreadcrumbs";

export function DiscoverTeamPage() {
    const { id } = useParams();

    useEffect(() => { setScrollBehavior() }, [])

    const { data: response, isLoading, error } = client.getDiscoverTeam.useQuery({ id: parseInt(id || "") }, { queryKey: ["discoverTeamDetail"] })

    if (error) {
        const code = error?.response.status;

        if (code === 404) {
            return (
                <div>
                    <NotFoundPage />
                </div>
            );
        }
    }

	const data: DiscoverTeamGetResponse = response?.data || {}

	return (
        <div className="discover-container">
            <div className="pageHeading">
				{isLoading
					? <SkeletonBox style={{ width: "300px", height: "32px", margin: "35px 0 35px 0" }} />
					: <DiscoverBreadcrumbs items={[
						...(data.club ? [{
							label: data.club.name,
							route: `/discover/club/${data.club.id}`,
							note: data.club.id,
						}] : []),
						{
							label: 'Teams',
							route: '/discover/team'
						},
						{
							label: data.name || 'team',
							note: data.id,
						},
					]} />
				}
			</div>
			{isLoading
				? <PlayerUserDetailSkeleton />
				: <DiscoverTeamDetail teamData={data} />}
        </div>
    )
}
